import axios from "axios";

const API_GO = process.env.REACT_APP_API_GO;

export const getProductLackDays = async ({ product_id, business_center_ids }) => {
	const { data } = await axios.get(`${API_GO}/app/maintainer/products/lack_days`, {
		params: {
			product_id,
			business_center_ids: business_center_ids.join(","),
		},
	});
	return data;
};
